import { t } from '@/i18n';
import { BreadcrumbInfoItems } from 'src/components/SimpleBreadcrumb';

export const breadcrumb: BreadcrumbInfoItems = [
  {
    label: t('pages.application_championship_matches.breadcrumb.label1'),
    link: '/application',
  },
  {
    label: t('pages.application_championship_matches.breadcrumb.label2'),
    link: '/application/championships',
  },
  {
    label: t('pages.application_championship_matches.breadcrumb.label3'),
  },
];
